import React from 'react';
import './StarRating.css';

function StarRating({ rating, reviewCount }) {
  // Round rating to nearest 0.5
  const roundedRating = Math.round(rating * 2) / 2;

  // Generate array of 5 stars
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (i <= Math.floor(roundedRating)) {
      // Full star
      stars.push(<span key={i} className="star-filled">★</span>);
    } else if (i === Math.ceil(roundedRating) && roundedRating % 1 !== 0) {
      // Half star
      stars.push(<span key={i} className="star-half">★</span>);
    } else {
      // Empty star
      stars.push(<span key={i} className="star-empty">☆</span>);
    }
  }

  return (
    <div className="star-rating-container">
      <div className="star-rating-stars">
        {stars}
      </div>
      {reviewCount != null && <span className="review-count">({reviewCount})</span>}
    </div>
  );
}

export default StarRating;
